import { put } from 'redux-saga/effects';
import { handleRedirect, logoutUser } from '../actions';

// ErrorInfo の forceLogout が true の場合と同等の処理を行う
export function* sessionExpiryErrorHandler() {
  yield put(logoutUser({ successAction: handleRedirect({ url: '/login', isInner: false }) }));
}
